import { cn } from '@/lib/utils'

import horizontalLight from '@/assets/brand/logo-horizontal-light.svg'
import horizontalDark from '@/assets/brand/logo-horizontal-dark.svg'
import signLight from '@/assets/brand/logo-sign-light.svg'
import signDark from '@/assets/brand/logo-sign-dark.svg'
import squareLight from '@/assets/brand/logo-square-light.svg'
import squareDark from '@/assets/brand/logo-square-dark.svg'

export type LogoVariant = 'sign' | 'horizontal' | 'square'

const SOURCES: Record<LogoVariant, { light: string; dark: string }> = {
  sign: { light: signLight, dark: signDark },
  horizontal: { light: horizontalLight, dark: horizontalDark },
  square: { light: squareLight, dark: squareDark },
}

export interface LogoProps {
  /** Lockup to render. `sign` = mark only, `horizontal` = mark + wordmark, `square` = stacked. Default: horizontal */
  variant?: LogoVariant
  /** Extra classes applied to both theme variants — set height here (e.g. `h-7 w-auto`). */
  className?: string
  /** Accessible label. Default: "Ensafely" */
  alt?: string
}

/**
 * Ensafely brand logo. Ships the official design-team SVGs and swaps light/dark
 * lockups via the `.dark` class on the document root — no JS theme read needed,
 * so there is no flash on first paint. Size it through `className` (height +
 * `w-auto`); aspect ratio is preserved from the source artwork.
 */
export function Logo({ variant = 'horizontal', className, alt = 'Ensafely' }: LogoProps) {
  const src = SOURCES[variant]
  return (
    <>
      <img src={src.light} alt={alt} className={cn('block dark:hidden', className)} />
      <img src={src.dark} alt="" aria-hidden className={cn('hidden dark:block', className)} />
    </>
  )
}
